// extracted by mini-css-extract-plugin
export var actionIcon = "_uc-0";